export default "__VITE_ASSET__Bk6qJxJW__"